import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/img/icons/cart.svg'


const _hoisted_1 = { class: "shop-wrap ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "shop-card-wrap style-one gx-0" }
const _hoisted_4 = { class: "shop-promo style-one lh-1 position-absolute text-white" }
const _hoisted_5 = { class: "shop-img overflow-hidden" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "shop-info d-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "fs-20" }
const _hoisted_9 = { class: "fs-20 fw-bold f-secondary text_primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"row mb-30\"><div class=\"col-lg-8 col-md-6\"><div class=\"d-md-flex align-items-center\"><form action=\"#\" class=\"search-form position-relative\"><input type=\"search\" placeholder=\"Search Here\"><button type=\"submit\" class=\"position-absolute border-0 d-flex flex-column align-items-center justify-content-center\"><i class=\"ri-search-line\"></i></button></form><p class=\"search-result mb-0 ms-3\">Showing 1–9 of 130 results</p></div></div><div class=\"col-lg-4 col-md-6 text-md-end\"><select class=\"filter-cat\"><option value=\"0\">Default Shorting</option><option value=\"0\">Short by latest</option><option value=\"1\">Short by Popular</option><option value=\"2\">Low to High</option></select></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "shop-card position-relative",
            key: product.id
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(product.state), 1),
            _createVNode(_component_router_link, {
              class: "add-to-cart position-absolute",
              to: "/cart"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Image"
                }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: product.image,
                alt: "Image",
                class: "d-block mx-auto transition"
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _cache[1] || (_cache[1] = _createStaticVNode("<ul class=\"ratings list-style\"><li><i class=\"ri-star-s-fill\"></i></li><li><i class=\"ri-star-s-fill\"></i></li><li><i class=\"ri-star-s-fill\"></i></li><li><i class=\"ri-star-s-fill\"></i></li><li><i class=\"ri-star-s-fill\"></i></li></ul>", 1)),
                _createElementVNode("h3", _hoisted_8, [
                  _createVNode(_component_router_link, { to: "/product-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(product.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createVNode(_component_router_link, {
                  to: "/shop-left-sidebar",
                  class: "shop-cat"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(product.category), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("span", _hoisted_9, " $" + _toDisplayString(product.price), 1)
            ])
          ]))
        }), 128))
      ]),
      _cache[3] || (_cache[3] = _createStaticVNode("<ul class=\"page-nav list-style text-center mt-5\"><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"><i class=\"ri-arrow-left-s-line\"></i></a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle active\" href=\"#\"> 01 </a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"> 02 </a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"> 03 </a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"><i class=\"ri-arrow-right-s-line\"></i></a></li></ul>", 1))
    ])
  ]))
}